import { totalSharesConfig } from './../totalShares';
import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerSharesConfig = {
    ...totalSharesConfig,
    size: SIZE_50,
    name: 'kpi.linkedin.mediaviewer.shares',
    tooltip: null,
    loader: MediaViewerKpiLoader
};
